import { render, staticRenderFns } from "./RealizujacaMarzenia.vue?vue&type=template&id=56835406&scoped=true&"
import script from "./RealizujacaMarzenia.vue?vue&type=script&lang=js&"
export * from "./RealizujacaMarzenia.vue?vue&type=script&lang=js&"
import style0 from "./RealizujacaMarzenia.vue?vue&type=style&index=0&id=56835406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56835406",
  null
  
)

export default component.exports